export default __webpack_public_path__ + "static/media/delete.80fa6c0c.svg";